import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ProcessBarCondition } from 'src/app/const/const';
import { BUTTON, COMMON_TEXT, SYSTEM_SETTING } from '../../../const/text-common';
import { ButtonType, LambdaStatus, StatusSynsMasterData } from '../../../enum/common-enum';
import { ModalTemplate } from '../../../models/common-model';
import { OfficeAPIService } from '../../../services/modules/office.service';
import { SyncDataOracleService } from '../../../services/modules/sync-data-oracle.service';
import {ErrorHandleService} from 'src/app/services/error-handle.service';
import {FUNCTION_TITLE_TEXT} from 'src/app/const/error-text';
import { ClearProcessService } from 'src/app/services/clear-process.service';
import { StepFunctionService } from 'src/app/services/modules/step-function.service';
@Component({
  selector: 'pivot-sync-master-data',
  templateUrl: './sync-master-data.component.html',
  styleUrls: ['./sync-master-data.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SyncMasterDataComponent implements OnInit {
 
  BUTTON = BUTTON;
  SYSTEM_SETTING = SYSTEM_SETTING;
  COMMON_TEXT = COMMON_TEXT;
  buttonType = ButtonType;
  syncInfoDetailModal = new ModalTemplate();
  showSyncInfoDetailDialog = false;
  syncDetailData: any[] = [];
  isSyncing: boolean = false;

  isDarkMode: boolean = true;
  iconType: boolean = false;
  syncStatusIconSrc: string = "";
  statusOfAllSyns: StatusSynsMasterData ; // 0 : loading, 1 : sucessfull, 2: fail

  firstTimeCalling: boolean = true;
  intervalIdList: any[] = [];

  constructor(
    private syncDataOracle: SyncDataOracleService,
    private errorHandleService: ErrorHandleService,
    private clearProcessService: ClearProcessService,
    private stepFunctionService: StepFunctionService
  ) { 
    const bodyElement = document.getElementsByTagName("body")[0];
    this.isDarkMode = bodyElement.classList.contains("navi") || bodyElement.classList.contains("dark") ? true : false;
    this.syncStatusIconSrc = this.isDarkMode ? 'dark': 'normal' ;
  }

  ngOnInit(): void {
  }

  async onSyncMasterData() {
    this.statusOfAllSyns = StatusSynsMasterData.LOADING;
    this.errorHandleService.setFunctionTitle(FUNCTION_TITLE_TEXT.SYNC_DATA_FAIL);
    this.errorHandleService.setIsNotShowFunctionTitle(true);
    if (this.isSyncing === false) {
      this.isSyncing = true;
      this.syncDetailData = [];
      this.syncDetailData.push({ name: '組織データの同期を実装しています。', status: ProcessBarCondition.NOT_START });
      this.syncDetailData.push({ name: '事業所データの同期を実装しています。', status: ProcessBarCondition.NOT_START });
      this.syncDetailData.push({ name: 'ブロックデータの同期を実装しています。', status: ProcessBarCondition.NOT_START });
      this.syncDetailData.push({ name: 'ユニットデータの同期を実装しています。', status: ProcessBarCondition.NOT_START });
      this.syncDetailData.push({ name: '事業所サービスデータの同期を実装しています。', status: ProcessBarCondition.NOT_START });
      this.syncDetailData.push({ name: '部屋マスタデータの同期を実装しています。', status: ProcessBarCondition.NOT_START });
      this.syncDetailData.push({ name: 'タイトルマスタデータの同期を実装しています。', status: ProcessBarCondition.NOT_START });

      this.openSyncInfoDetailDialog();

      for (let i = 0; i <= 6; i++) {
        this.syncDetailData[i].status = ProcessBarCondition.START;
      }
      for (let i = 0; i <= 5; i++) {   
        setTimeout(() => {
          this.syncDetailData[i].status = ProcessBarCondition.DONE;
        }, (i + 1) * 500);
      }
      await this.syncMasterData();
    } else {
      this.openSyncInfoDetailDialog();
    }
  }

  sendErrorIfConditionFalse(condition: boolean) {
    if(condition == false) {
      let errorStatus = this.errorHandleService.isHasErrorDialogOrErrorScreenDisplay;
      if(errorStatus == false) {
        this.errorHandleService.openUnknowErrorDialog();
      }
    }
  }

  openSyncInfoDetailDialog() {
    this.syncInfoDetailModal.header = this.COMMON_TEXT.SYNC_MASTER_LIST;
    this.syncInfoDetailModal.style = { 'width': 'auto','background': '#000' };
    this.syncInfoDetailModal.breakpoints = { '960px': '75vw', '640px': '100vw' };
    this.syncInfoDetailModal.closable = false;
    this.syncInfoDetailModal = { ...this.syncInfoDetailModal };
    this.showSyncInfoDetailDialog = true;
    this.statusOfAllSyns = StatusSynsMasterData.LOADING;
  }

  handleModalDetailClose = () => this.showSyncInfoDetailDialog = false;


  //#region STEP FUNCTION
  checkIfStopInterval(screenCode: any, intervalId: any): boolean {
    let result: boolean = false;
    if(this.firstTimeCalling) {
      this.firstTimeCalling = false;
      this.clearProcessService.setScreenCode(screenCode);
    }
    const holderCode = this.clearProcessService.getScreenCode();
    if(holderCode != screenCode) {
      clearInterval(intervalId);
      this.removeIntervalIdToList(intervalId);
      result = true;
    }

    return result;
  }
  removeIntervalIdToList(id: any) {
    this.intervalIdList = this.intervalIdList.filter(e => e != id);
    this.clearProcessService.removeIntervalIdList(id);
    this.firstTimeCalling = true;
  }
  addIntervalIdToList(id: any) {
    if(this.intervalIdList.includes(id)) return;
    this.intervalIdList.push(id);
    this.clearProcessService.setIntervalId(id);
  }

  async syncMasterData() {
    const res = await this.syncDataOracle.syncMasterData();
    if (res.statuscode === 200 && res?.data?.executionarn) {
      const screenCode = 1 + Math.random();
      let intervalId = setInterval(() => {
        if (this.checkIfStopInterval(screenCode, intervalId)) {
          return;
        }
        this.stepFunctionService.checkStatus(res.data.executionarn).then(async resLamda => {
          if (resLamda.statuscode && resLamda.statuscode == 500) {
            clearInterval(intervalId);
            this.removeIntervalIdToList(intervalId);
            this.syncDetailData[6].status = ProcessBarCondition.ERROR;
            this.sendErrorIfConditionFalse(false);
            this.isSyncing = false;
            this.syncInfoDetailModal.closable = true;
            const allDone = this.syncDetailData.every(detail => detail.status == ProcessBarCondition.DONE);
            this.statusOfAllSyns = allDone ? StatusSynsMasterData.SUCCESS : StatusSynsMasterData.FAILED;

          } else {
            if (resLamda.data.status === LambdaStatus.SUCCEEDED) {
              clearInterval(intervalId);
              this.removeIntervalIdToList(intervalId);

              let data = JSON.parse(resLamda.data.output);


              if (data?.syncCoreMasterResult) {
                const errorTypeToIndex: Record<string, number> = {
                  corp: 0,
                  office: 1,
                  block: 2,
                  unit: 3,
                  service: 4,
                };
                const indexsError = new Set(
                  data.syncCoreMasterResult
                    .filter((item: any) => item.status === "ERROR")
                    .map((item: any) => errorTypeToIndex[item.type])
                    .filter((index: any) => index !== undefined)
                );

                for (let i = 0; i <= 4; i++) {
                  this.syncDetailData[i].status = indexsError.has(i) ? ProcessBarCondition.ERROR : ProcessBarCondition.DONE;
                }
              } else {
                for (let i = 0; i <= 4; i++) {
                  this.syncDetailData[i].status = ProcessBarCondition.ERROR;
                }
              }

              if (data?.syncRoomResult) {
                this.syncDetailData[5].status = data.syncRoomResult.status === "ERROR" ? ProcessBarCondition.ERROR : ProcessBarCondition.DONE;
              } else {
                this.syncDetailData[5].status = ProcessBarCondition.ERROR;
              }

              
              if (data?.syncTitleMasterResult) {
                if (data.syncTitleMasterResult?.some((item: any) => item.status == "ERROR")) {
                  this.syncDetailData[6].status = ProcessBarCondition.ERROR;
                } else {
                  this.syncDetailData[6].status = ProcessBarCondition.DONE;
                }
              } else {
                this.syncDetailData[6].status = ProcessBarCondition.ERROR;
              }

              this.isSyncing = false;
              this.syncInfoDetailModal.closable = true;
              const allDone = this.syncDetailData.every(detail => detail.status == ProcessBarCondition.DONE);
              this.statusOfAllSyns = allDone ? StatusSynsMasterData.SUCCESS : StatusSynsMasterData.FAILED;

            }
            else if (resLamda.data.status != LambdaStatus.RUNNING) {
              clearInterval(intervalId);
              this.removeIntervalIdToList(intervalId);
              // update status
              this.syncDetailData[6].status = ProcessBarCondition.ERROR;
              this.sendErrorIfConditionFalse(false);
              this.isSyncing = false;
              this.syncInfoDetailModal.closable = true;
              const allDone = this.syncDetailData.every(detail => detail.status == ProcessBarCondition.DONE);
              this.statusOfAllSyns = allDone ? StatusSynsMasterData.SUCCESS : StatusSynsMasterData.FAILED;
            }
          }


        })
      }, 3000);
      this.addIntervalIdToList(intervalId);
    }
    else {
      // update status
      this.syncDetailData[6].status = ProcessBarCondition.ERROR;
      this.sendErrorIfConditionFalse(false);
      this.isSyncing = false;
      this.syncInfoDetailModal.closable = true;
    }
  }
  //#endregion
}
